import { render, staticRenderFns } from "./SupportAdmin.vue?vue&type=template&id=3b248bb6&"
import script from "./SupportAdmin.vue?vue&type=script&lang=js&"
export * from "./SupportAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports